module.exports = __webpack_public_path__ + "static/img/img_title_moralcheck.0bd9bf4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/img_title_moralcheck.png
// module id = 567
// module chunks = 1